import React from "react";
import { Switch } from "react-router-dom";
import { connect } from "react-redux";
import Order from "../menu/order";

import PrivateRoute from "components/common/PrivateRoute";

const OrdersRouter = props => (
    <div className="px-5">
        <Switch>
            <PrivateRoute
                exact
                path={`${props.match.url}/`}
                component={Order}
            />
        </Switch>
    </div>
);

export default connect()(OrdersRouter);